import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ActivityPlayButtonOverlay.module.scss';
import playButton from 'assets/svg/play-button.svg';
import { t } from '../../translations';

const ActivityPlayButtonOverlay = ({ onOverlayClick }) => {
  const playButtonRef = useRef();
  const overlayRef = useRef();
  const [showFocus, setShowFocus] = useState(false);

  const onClick = () => onOverlayClick();
  const onKeyDown = e => {
    if (e.key === 'Enter' || e.keyCode == 32) {
      playButtonRef?.current?.click();
    }
  };
  const onTouchEnd = () => onOverlayClick();

  useEffect(() => {
    if (!playButtonRef.current) return;
    playButtonRef.current.focus();
    setShowFocus(true);
  }, [playButtonRef.current]);

  return (
    <div className={styles.overlay} ref={overlayRef} tabIndex={-1} onKeyDown={onKeyDown}>
      <div
        className={styles.playButtonContainer}
        onClick={onClick}
        onTouchEnd={onTouchEnd}
        tabIndex={-1}
      >
        <div
          aria-label={t('Play')}
          className={[styles.playButton, showFocus ? styles.focusVisible : ''].join(' ')}
          onClick={onClick}
          onKeyDown={onKeyDown}
          role="button"
          tabIndex={0}
          ref={playButtonRef}
          onBlur={() => setShowFocus(false)}
          onFocus={() => setShowFocus(true)}
        >
          <img alt={t('Play')} src={playButton} />
        </div>
      </div>
    </div>
  );
};

ActivityPlayButtonOverlay.propTypes = {
  onOverlayClick: PropTypes.func
};

export default ActivityPlayButtonOverlay;
